/**
  * 部门 接口的统一出口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const intangibleCate = {
  // 列表
  list (params) {
    return axios.get(api + 'intangibleCate/list', { params: params })
  },
  // 添加
  create (params) {
    return axios.post(api + 'intangibleCate/create', qs.stringify(params))
  },
  // 修改
  edit (params) {
    return axios.post(api + 'intangibleCate/edit', qs.stringify(params))
  },
  // 修改状态
  status (params) {
    return axios.post(api + 'intangibleCate/status', qs.stringify(params))
  },
  // 删除
  remove (params) {
    return axios.post(api + 'intangibleCate/remove', qs.stringify(params))
  },
  // 详情
  detail (params) {
    return axios.post(api + 'intangibleCate/detail', qs.stringify(params))
  }

}

// 导出接口
export default intangibleCate
